import styled, { css } from 'styled-components';
import { Medium } from '../Typography';

const Container = styled.div`
  background: transparent;
  height: 60px;
  top: ${({ absoluteMode, simpleHeader, stickyWithoutHeader, subNav }) => {
    if (absoluteMode) {
      return simpleHeader || !subNav ? '152px' : stickyWithoutHeader ? '137px' : '185px';
    }
  }};

  ${({ absoluteMode }) => {
    if (absoluteMode)
      return `
      position: absolute;
      width: 100%;
      z-index: 100;
  `;
  }};

  .breadcrumb--arrow {
    margin-left: 8px;
  }
  .breadcrumb--icon {
    margin-left: 4px;
  }

  .breadcrumb--arrow.reverse {
    transform: scaleX(-1);
    margin-left: 0;
    margin-right: 15px;
  }

  @media (max-width: 1450px) {
    top: ${({ absoluteMode, simpleHeader }) =>
      absoluteMode && simpleHeader ? '122px' : absoluteMode ? '100px' : 'inherit'};
    margin-top: ${({ simpleHeader }) => simpleHeader && '0px'};
  }

  @media (max-width: 576px) {
    height: 48px;

    .breadcrumb--icon {
      width: 17px;
    }
  }
`;

const ChildLink = styled(Medium)`
  color: ${({ darkTheme }) => (darkTheme ? 'var(--neutral-7)' : 'var(--white-color)')};
  font-size: 16px;

  @media (max-width: 576px) {
    font-size: 17px;
  }
`;

const ParentLink = styled(Medium)`
  color: ${({ darkTheme }) => (darkTheme ? 'var(--neutral-text-color)' : '#FFFFFF')};
  font-size: 16px;
  margin-right: 8px;

  @media (max-width: 576px) {
    font-size: 17px;
    margin-right: 0;
    display: flex;
    align-items: center;
  }
`;

const InnerContainer = styled.div`
  max-width: 1296px;
  margin: 0px auto;

  display: flex;
  align-items: center;
  height: 100%;

  ${({ layout }) => {
    if (layout === 'marketingpro') {
      return mpBreadcrumbsPadding;
    } else if (layout === 'toolbox') {
      return tbBreadcrumbsPadding;
    } else {
      return wpBreadcrumbsPadding;
    }
  }};

  @media (max-width: 576px) {
    padding: 0 20px;
  }
`;

const mpBreadcrumbsPadding = css`
  padding: 0px;

  @media (max-width: 1600px) {
    padding: 0 20px;
  }
`;
const tbBreadcrumbsPadding = css`
  padding: 0 56px;

  @media (max-width: 992px) {
    padding: 0 28px;
  }
`;

const wpBreadcrumbsPadding = css`
  padding: 0 68px;

  @media (max-width: 992px) {
    padding: 0 28px;
  }
`;

export { ChildLink, Container, InnerContainer, ParentLink };
